import React, { useState } from 'react';
import * as Images from '../../../assets';
import { fetchWithFormDataToken } from '../../../apiGeneralFunction';
import { toast } from 'react-toastify';

const ContactInquiry = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        mobileNumber: '',
        comments: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

        const validateForm = () => {
            const { fullName, email, mobileNumber, comments } = formData;
    
            if (!fullName) {
                toast.error("Full Name is required.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
            if (!email) {
                toast.error("Email is required.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                toast.error("Invalid email format.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
            if (!mobileNumber) {
                toast.error("Phone Number is required.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(mobileNumber)) {
                toast.error("Invalid phone number format. It should be 10 digits.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
            if (!comments) {
                toast.error("Comments are required.", { position: 'top-center', autoClose: 2000 });
                return false;
            }
    
            return true;
        };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const abortController = new AbortController();

        try {
            const formdata = new FormData();
            formdata.append("name", formData.fullName);
            formdata.append("email", formData.email);
            formdata.append("mobile", formData.mobileNumber);
            formdata.append("comment", formData.comments);

            console.log("Form Data Submitted:", formData);

            const result = await fetchWithFormDataToken('user-enquiry-create', formdata, abortController);

            if (result?.status === true) {
                toast.success(result?.message || "Form submitted successfully.", {
                    position: 'top-center',
                    autoClose: 2000,
                });

                // Reset the form data after successful submission
                setFormData({
                    fullName: '',
                    email: '',
                    mobileNumber: '',
                    comments: '',
                });
            } else {
                toast.error(result?.message || "Submission failed.", {
                    position: 'top-center',
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An error occurred while submitting the form.", {
                position: 'top-center',
                autoClose: 2000,
            });
        } finally {
            abortController.abort();
        }
    };

    return (
        <section id='contact' className='bg-white p-6 gap-4'>
            <hr />
            <div className="flex flex-col md:flex-row bg-gray-100 p-8 rounded-lg shadow-lg max-w-5xl mx-auto mt-8">

                <div className="text-white p-8 rounded-lg md:w-2/5 relative" style={{ backgroundImage: `url(${Images.inquiry_image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className="absolute inset-0 rounded-lg"></div>
                    <div className="relative z-10">
                        <h2 className="text-3xl font-bold">Contact Us</h2>
                        <p className="mt-2 text-gray-300">Let's Contact to Our Support Team!</p>
                        <div className="mt-8 space-y-6">
                            <p className="flex items-center space-x-2"><span className='mr-3' style={{fontSize: '24px'}}><i class="fa fa-phone"></i> </span>{" "} +91 70469 00096</p>
                            <p className="flex items-center space-x-2"><span className='mr-3' style={{fontSize: '20px'}}><i class="fa fa-envelope"></i> </span>{" "} info@headway.org.in</p>
                            <p className="flex items-start space-x-2">
                                <span className='mr-3' style={{ fontSize: '24px' }}><i className="fa fa-map-marker"></i></span>
                                <span>101-Shree Kashi Parekh Complex, First Floor, Behind Bhagavati Chambers, Near Swastik Cross Rd, C G Road, Navrangpura, Ahmedabad, Gujarat 380009</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white p-8 rounded-lg md:w-3/5">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-2">
                                Full Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                placeholder="Enter Your Full Name"
                                onChange={handleChange}
                                required
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium mb-2">Email <span className="text-red-500">*</span></label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter Email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label htmlFor="mobileNumber" className="block text-sm font-medium mb-2">Mobile Number <span className="text-red-500">*</span></label>
                            <input
                                type="tel"
                                id="mobileNumber"
                                name="mobileNumber"
                                placeholder="Enter Mobile Number"
                                value={formData.mobileNumber}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label htmlFor="comments" className="block text-sm font-medium mb-2">Comments <span className="text-red-500">*</span></label>
                            <textarea
                                id="comments"
                                name="comments"
                                placeholder="Enter comments"
                                value={formData.comments}
                                onChange={handleChange}
                                rows="3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                style={{ height: '100px', resize: 'none' }}
                            />
                        </div>
                        <div className="flex justify-center">
                            <button
                                type="submit"
                                className="px-6 py-3 about-us-btn text-white font-medium rounded-md hover:about-us-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default ContactInquiry